import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config } from '../../shared';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import {FileLabelListContainerModel} from '../../../../../../models';

@Injectable({providedIn: 'root'})

export class FileLabelListService extends BaseApiTemplateService<FileLabelListContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FM_MODULE + 'label-lists/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FM_MODULE + 'label-lists/backoffice-ep';
    this.httpClient = http;
  }
}
